import type { TabParams } from '@/types';

function compareKeys(a: string, b: string): number {
  if (a < b) return -1;
  return a > b ? 1 : 0;
}

/**
 * Deterministic instance key for a multi-instance tab: keys sorted,
 * `undefined` dropped, entries JSON-stringified. Returns `undefined` when no
 * params are supplied, which keeps the one-tab-per-tool behavior.
 */
export function buildInstanceKey(params: TabParams | undefined): string | undefined {
  if (!params) return undefined;
  const entries = Object.entries(params)
    .filter(([, value]) => value !== undefined)
    .sort(([a], [b]) => compareKeys(a, b));
  return JSON.stringify(entries);
}

/** Tab identity: the tool's `componentKey`, plus `#instanceKey` when present. */
export function tabIdentity(componentKey: string, instanceKey?: string): string {
  return instanceKey === undefined ? componentKey : `${componentKey}#${instanceKey}`;
}
